export default {
  'form.basicform.basic.title': 'Basic form',
  'form.basicform.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',

  'form.basicform.email.required': 'Please enter your email!',
  'form.basicform.email.wrong-format': 'The email address is in the wrong format!',
  'form.basicform.userName.required': 'Please enter your userName!',
  'form.basicform.password.required': 'Please enter your password!',
  'form.basicform.password.twice': 'The passwords entered twice do not match!',
  'form.basicform.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'form.basicform.strength.strong': 'Strength: strong',
  'form.basicform.strength.medium': 'Strength: medium',
  'form.basicform.strength.short': 'Strength: too short',
  'form.basicform.confirm-password.required': 'Please confirm your password!',
  'form.basicform.phone-number.required': 'Please enter your phone number!',
  'form.basicform.phone-number.wrong-format': 'Malformed phone number!',
  'form.basicform.verification-code.required': 'Please enter the verification code!',
  'form.basicform.title.required': 'Please enter a title',
  'form.basicform.date.required': 'Please select the start and end date',
  'form.basicform.goal.required': 'Please enter a description of the goal',
  'form.basicform.standard.required': 'Please enter a metric',

  'form.basicform.form.get-captcha': 'Get Captcha',
  'form.basicform.captcha.second': 'sec',
  'form.basicform.form.optional': ' (optional) ',
  'form.basicform.form.submit': 'Submit',
  'form.basicform.form.save': 'Save',
  'form.basicform.email.placeholder': 'Email',
  'form.basicform.password.placeholder': 'Password',
  'form.basicform.confirm-password.placeholder': 'Confirm password',
  'form.basicform.phone-number.placeholder': 'Phone number',
  'form.basicform.verification-code.placeholder': 'Verification code',
  'form.basicform.title.label': 'Title',
  'form.basicform.title.placeholder': 'Give the target a name',
  'form.basicform.date.label': 'Start and end date',
  'form.basicform.placeholder.start': 'Start date',
  'form.basicform.placeholder.end': 'End date',
  'form.basicform.goal.label': 'Goal description',
  'form.basicform.goal.placeholder': 'Please enter your work goals',
  'form.basicform.standard.label': 'Metrics',
  'form.basicform.standard.placeholder': 'Please enter a metric',
  'form.basicform.client.label': 'Client',
  'form.basicform.label.tooltip': 'Target service object',
  'form.basicform.client.placeholder':
    'Please describe your customer service, internal customers directly AT Name / job number',
  'form.basicform.invites.label': 'Inviting critics',
  'form.basicform.invites.placeholder':
    'Please direct AT Name / job number, you can invite up to 5 people',
  'form.basicform.weight.label': 'Weight',
  'form.basicform.weight.placeholder': 'Please enter weight',
  'form.basicform.public.label': 'Target disclosure',
  'form.basicform.label.help': 'Customers and invitees are shared by default',
  'form.basicform.radio.public': 'Public',
  'form.basicform.radio.partially-public': 'Partially public',
  'form.basicform.radio.private': 'Private',
  'form.basicform.publicUsers.placeholder': 'Open to',
  'form.basicform.option.A': 'Colleague A',
  'form.basicform.option.B': 'Colleague B',
  'form.basicform.option.C': 'Colleague C',
};
